<template>
    <span>
        <a href="https://www.linkedin.com/in/tobias-hubold" target="_blank"><img src="/img/li_logo.svg"></a> | <a href="https://www.xing.com/profile/Tobias_Hubold" target="_blank"><img height="30px" src="/img/xing-icon.svg"></a>
    </span>
</template>

<script>
export default {
  name: 'Network',
  props: {
    msg: String
  }
}
</script>